import React, { useContext } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Calculation } from '../../../../services/types/Calculator';
import { Button } from '../../../../shared/components';
import { Operation } from '../../../../services/types/Operation';
import { dateTimeFormat } from '../../../../shared/misc/utils';
import CalcStatusBadge from './CalcStatusBadge';
import calculatorService from '../../../../services/calculatorService';
import MainContext from '../../../App/MainProvider/context';
import { SectorType } from './Utils/sectorType';
import NumberFormatterSinSeparador from './NumberFormatterSinSeparador';

interface Props {
  operation: Operation;
  calculation: Calculation;
  isSent: boolean;
  handleCalculateClick?: (rowId: number) => void;
  handleDeleteClick?: (rowId: number) => void;
  setLoadingSpinner: (isLoading: boolean) => void;
}

const CalculatorVersion = (props: Props) => {
  const {
    operation,
    calculation,
    isSent,
    handleCalculateClick,
    handleDeleteClick,
    setLoadingSpinner,
  } = props;
  const { notify, service } = useContext(MainContext);
  const navigate = useNavigate();

  const download = async (actionPlanId: number) => {
    try {
      setLoadingSpinner(true);
      await service(() => calculatorService.downloadDocument(actionPlanId), {});
    } catch (error) {
      notify('Error', 'Failed to download document', 'error');
      // eslint-disable-next-line no-console
      console.error('Error downloading document:', error);
    } finally {
      setLoadingSpinner(false);
    }
  };

  const { t } = useTranslation();
  const currentSectorId: SectorType = calculation.sectorId;

  const handleNavigateCalculateClick = () => {
    const fromUrl = `/operations/${operation.number}/calculator`;
    const url = `${fromUrl}/${calculation.id}?from=${fromUrl}&sectorId=${currentSectorId}`;
    navigate(url);
  };

  return (
    <tr>
      <td>{calculation.sector}</td>
      <td>{calculation.country}</td>
      <td>{calculation.unit}</td>
      <td>{dateTimeFormat(calculation.modifiedOn)}</td>
      <td>{calculation.modifiedBy}</td>
      <td>
        <NumberFormatterSinSeparador value={calculation.construction} />
      </td>
      <td>
        <NumberFormatterSinSeparador value={calculation.operation} />
      </td>
      <td>
        <NumberFormatterSinSeparador value={calculation.normalized} />
      </td>
      <td>{!isSent && <CalcStatusBadge code={calculation.status} />}</td>
      <td colSpan={2} className="text-right">
        {!isSent && handleCalculateClick && (
          <Button
            key={`tv_btn_calculate_${calculation.id}`}
            className="btn-tertiary no-padding action-calculator"
            htmlId={`tv_btn_calculate_${calculation.id}`}
            icon="calculator"
            text=""
            onClick={handleNavigateCalculateClick}
          />
        )}
        {!isSent && handleDeleteClick && (
          <Button
            key={`tv_btn_delete_${calculation.id}`}
            className="btn-tertiary no-padding action-calculator"
            htmlId={`tv_btn_delete_${calculation.id}`}
            icon="trash-alt"
            text=""
            onClick={() => {
              if (handleDeleteClick) {
                handleDeleteClick(calculation.id);
              }
            }}
          />
        )}
        {calculation.pfdCreated && (
          <Button
            key={`tv_btn_download_${calculation.id}`}
            className="btn-tertiary no-padding action-calculator"
            htmlId={`tv_btn_download_${calculation.id}`}
            icon="file-download"
            text={t('')}
            onClick={() => download(calculation.id)}
          />
        )}
      </td>
    </tr>
  );
};

export default CalculatorVersion;
